import { Skeleton, Stack } from "@mui/material";
import { keyframes } from "@emotion/react";

// Define a custom wave animation
const customWave = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const SkeletonGroup = () => (
  <Stack spacing={1.5}>
    {[...Array(4)].map((_, idx) => (
      <Skeleton
        key={idx}
        variant="rounded"
        height={40}
        sx={{
          width: "100%",
          bgcolor: "#a6a6a6",
          borderRadius: "10px",
          position: "relative",
          overflow: "hidden",

          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            background: "linear-gradient(90deg, transparent, #ffffff80, transparent)",
            animation: `${customWave} 2.5s infinite`,
          },
        }}
      />
    ))}
  </Stack>
);

export default SkeletonGroup;
